/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SwitchAuthScopesSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type SwitchAuthScopesRequest = {
  /**
   * The organization slug to switch scopes
   */
  organizationId?: string | undefined;
  /**
   * The project id to switch scopes too
   */
  projectId?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

export type SwitchAuthScopesResponse = {
  headers: { [k: string]: Array<string> };
};

/** @internal */
export type SwitchAuthScopesSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SwitchAuthScopesSecurity$outboundSchema: z.ZodMiniType<
  SwitchAuthScopesSecurity$Outbound,
  SwitchAuthScopesSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function switchAuthScopesSecurityToJSON(
  switchAuthScopesSecurity: SwitchAuthScopesSecurity,
): string {
  return JSON.stringify(
    SwitchAuthScopesSecurity$outboundSchema.parse(switchAuthScopesSecurity),
  );
}

/** @internal */
export type SwitchAuthScopesRequest$Outbound = {
  organization_id?: string | undefined;
  project_id?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const SwitchAuthScopesRequest$outboundSchema: z.ZodMiniType<
  SwitchAuthScopesRequest$Outbound,
  SwitchAuthScopesRequest
> = z.pipe(
  z.object({
    organizationId: z.optional(z.string()),
    projectId: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      organizationId: "organization_id",
      projectId: "project_id",
      gramSession: "Gram-Session",
    });
  }),
);

export function switchAuthScopesRequestToJSON(
  switchAuthScopesRequest: SwitchAuthScopesRequest,
): string {
  return JSON.stringify(
    SwitchAuthScopesRequest$outboundSchema.parse(switchAuthScopesRequest),
  );
}

/** @internal */
export const SwitchAuthScopesResponse$inboundSchema: z.ZodMiniType<
  SwitchAuthScopesResponse,
  unknown
> = z.pipe(
  z.object({
    Headers: z._default(z.record(z.string(), z.array(z.string())), {}),
  }),
  z.transform((v) => {
    return remap$(v, {
      "Headers": "headers",
    });
  }),
);

export function switchAuthScopesResponseFromJSON(
  jsonString: string,
): SafeParseResult<SwitchAuthScopesResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SwitchAuthScopesResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SwitchAuthScopesResponse' from JSON`,
  );
}
